var render = function render(){var _vm=this,_c=_vm._self._c;return _c('product-map',{attrs:{"respons":_vm.res,"num":9,"text":"新增导航"}})
}
var staticRenderFns = []

export { render, staticRenderFns }